import { gql } from '@apollo/client';

export default gql`
  query booking($reference: String!, $lastName: String) {
    booking(reference: $reference, lastName: $lastName) {
      reference
    }
  }
`;
